// @flow
import {
  PAGE_READY,
  PAGE_READINESS_RESET,
  SET_NAVBAR_VISIBILITY,
  SET_FOOTER_VISIBILITY,
  SET_CUREFY_DOMAIN,
} from './constants';
import type { Action } from './types';

export const pageReady = (): Action => ({
  type: PAGE_READY
});

export const setCurefyDomain = (req: any): Action => ({
  type: SET_CUREFY_DOMAIN,
  value: req?.headers.host === 'curefy.ai' || req?.headers.host === 'www.curefy.ai'
});

export const resetPageReadiness = (): Action => ({
  type: PAGE_READINESS_RESET
});

export const setNavbarVisibility = (payload: boolean) => ({
  type: SET_NAVBAR_VISIBILITY,
  payload
});

export const setFooterVisibility = (payload: boolean) => ({
  type: SET_FOOTER_VISIBILITY,
  payload
});
